import React from "react";
import Landing from "../components/Landing/SignUp";

const LoginPage = () => {
  return <Landing />;
};

export default LoginPage;
